import React, { useEffect } from "react";

import Main from '../components/Account/Main'
import Table from "../components/Account/Table";
import OurClients from "../components/Account/OurClients";
import WhatType from "../components/Account/WhatType";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function Account () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">
            <Main/>
            <Table/>
            <OurClients/>
            <WhatType/>
            <YourTradingJourney/>
        </div>
    );
}

export default Account;